// extracted by mini-css-extract-plugin
export default {"wrapper":"Image_wrapper__0TJNJ","fadein":"Image_fadein__znVYU"};